module.exports = __webpack_public_path__ + "10_hair_brown.2f8ab112.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/10_hair_brown.png
// module id = 5oVF
// module chunks = 0